import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

class PaginationFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterText: props.initialFilterText || '',
            sortBy: props.initialSortBy || '',
        };

        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSortChange = this.handleSortChange.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleClear = this.handleClear.bind(this);
    }

    handleFilterChange(e) {
        const value = e && e.target ? e.target.value : e;
        this.setState({filterText: value});
        if (this.props.onFilterChange) this.props.onFilterChange(value);
    }

    handleSortChange(e) {
        const value = e && e.target ? e.target.value : e;
        this.setState({sortBy: value});
        if (this.props.onSortChange) this.props.onSortChange(value);
    }

    handleApply() {
        if (this.props.onApply) this.props.onApply(this.state.filterText, this.state.sortBy);
    }

    handleClear() {
        this.setState({filterText: '', sortBy: ''}, () => {
            if (this.props.onClear) this.props.onClear();
        });
    }

    render() {
        const {filterText, sortBy} = this.state;
        const {filterPlaceholder, sortPlaceholder, sortOptions, applyLabel, resetLabel} = this.props;

        return (
            <div className="row mb-3 align-items-center">
                <div className="col-auto">
                    <FormattedMessage {...filterPlaceholder}>
                        {(placeholder) => (
                            <input
                                type="text"
                                className="form-control"
                                placeholder={placeholder}
                                value={filterText}
                                onChange={this.handleFilterChange}
                            />
                        )}
                    </FormattedMessage>
                </div>

                <div className="col-auto">
                    <select className="form-control" value={sortBy} onChange={this.handleSortChange}>
                        <FormattedMessage {...sortPlaceholder}>
                            {(txt) => <option value="">{txt}</option>}
                        </FormattedMessage>
                        {sortOptions && sortOptions.map((opt) => (
                            <FormattedMessage key={opt.value} {...opt.label}>
                                {(txt) => <option value={opt.value}>{txt}</option>}
                            </FormattedMessage>
                        ))}
                    </select>
                </div>

                <div className="col-auto">
                    <button type="button" className="btn btn-primary mr-2 mb-1" onClick={this.handleApply}>
                        <FormattedMessage {...applyLabel} />
                    </button>
                    {(filterText || sortBy) && (
                        <button type="button" className="btn btn-link mb-1" onClick={this.handleClear}>
                            <FormattedMessage {...resetLabel} />
                        </button>
                    )}
                </div>
            </div>
        );
    }
}

PaginationFilter.propTypes = {
    filterPlaceholder: PropTypes.object.isRequired,
    sortPlaceholder: PropTypes.object.isRequired,
    sortOptions: PropTypes.array,
    onFilterChange: PropTypes.func,
    onSortChange: PropTypes.func,
    onApply: PropTypes.func,
    onClear: PropTypes.func,
    storageKey: PropTypes.string,
    initialFilterText: PropTypes.string,
    initialSortBy: PropTypes.string,
    applyLabel: PropTypes.object.isRequired,
    resetLabel: PropTypes.object.isRequired,
};

PaginationFilter.defaultProps = {
    sortOptions: [],
};

export default PaginationFilter;
